<!-- CardRequestType -->
<template>
    <!-- start navigator -->
    <div class="container ps-lg-5 pe-lg-5 mt-1">
        <div class="row">
            <div class="
            col-12
            d-none d-lg-flex
            justify-content-between
            align-items-center
          ">
                <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">หน้าแรก</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
                        </li>
                        <li class="breadcrumb-item router-link active">
                            ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <!-- end navigator -->

    <div class="container-lg">
        <div class="row">
            <!-- Left Menu -->
            <div class="col-left-menu">
                <div class="left-menu">
                    <ul class="d-none d-lg-block">
                        <Menu />
                    </ul>
                </div>
            </div>
            <!-- Left Menu -->

            <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          ps-3
          pe-3
        " style="background-color: #f2f2f2">
                <div class="icon-back">
                    <router-link to="/AgenteService">
                        <img src="@/assets/images/arrow-blue.svg" class="w-100" />
                    </router-link>
                </div>
                <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100 font-family blue-1">
                    ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน
                </div>
            </div>

            <div class="col">

                <StepBar :steps="['เอกสารที่ต้องเตรียม', 'ประสงค์ขอทำบัตร', 'อัปโหลดเอกสาร', 'ชำระเงิน', 'เสร็จสิ้น']"
                    :current="1" />

                <div class="title d-none d-lg-block border-bottom font-family blue-1">
                    ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน
                </div>

                <div class="font-family-bla my-3">
                    <div class="card-wrap p-4">
                        <!-- Request Reason -->
                        <div class="mb-4">
                            <p class="fs-5 fw-bold">เลือกความประสงค์ขอทำบัตรประจำตัว เพื่อใช้ในการผ่านเข้า-ออกอาคารสำนักงาน ดังนี้</p>
                            <div class="form-check fs-5">
                                <input class="form-check-input" type="radio" name="requestReason" id="reason1" value="NEW" v-model="requestReason">
                                <label class="form-check-label" for="reason1">
                                    ทำบัตรครั้งแรก
                                </label>
                            </div>
                            <div class="form-check fs-5">
                                <input class="form-check-input" type="radio" name="requestReason" id="reason2" value="REN" v-model="requestReason">
                                <label class="form-check-label" for="reason2">
                                    ต่ออายุบัตร
                                </label>
                            </div>
                            <div class="form-check fs-5">
                                <input class="form-check-input" type="radio" name="requestReason" id="reason3" value="REP" v-model="requestReason">
                                <label class="form-check-label" for="reason3">
                                    ทำบัตรใหม่แทนบัตรเดิมที่สูญหาย หรือชำรุด (กรณีชำรุดต้องนำบัตรเดิมมาคืนด้วย)
                                </label>
                            </div>
                        </div>

                        <!-- Pickup Location -->
                        <div class="d-flex align-items-center flex-wrap">
                            <p class="fs-5 fw-bold mb-0 me-4">ต้องการรับบัตรที่</p>
                            <div class="form-check form-check-inline fs-5">
                                <input class="form-check-input" type="radio" name="pickupLocation" id="pickup1" value="BRN" v-model="pickupLocation">
                                <label class="form-check-label" for="pickup1">
                                    สาขา/AO ที่สังกัด
                                </label>
                            </div>
                            <div class="form-check form-check-inline fs-5">
                                <input class="form-check-input" type="radio" name="pickupLocation" id="pickup2" value="SEL" v-model="pickupLocation">
                                <label class="form-check-label" for="pickup2">
                                    รับด้วยตัวเองที่สำนักงานใหญ่ (เคาน์เตอร์สัญญาตัวแทน ชั้น 10)
                                </label>
                            </div>
                        </div>

                    </div>
                    
                    <!-- ปุ่มดำเนินการต่อ -->
                    <div class="text-end mt-4">
                        <button class="btn btn-bla w-25" @click="goNext" :disabled="!requestReason || !pickupLocation">
                            ถัดไป </button>
                    </div>

                </div>

            </div>

        </div>
    </div>

    <div v-if="this.Loading">
        <LoadingBs5></LoadingBs5>
    </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

import StepBar from "../StepBar.vue";

import '@/styles/SweetAlert2CustomCSS.css';

export default {
    name: "CardRequestType",
    components: {
        Menu,
        LoadingBs5,
        StepBar
    },
    data() {
        return {
            faCircleXmark: faCircleXmark,
            Loading: true,
            requestReason: null,
            pickupLocation: null,
        };
    },
    mounted() {
        if (this.$store.state.AgentCode == '') {
            this.$router.push('/');
        }

        this.Authorization();

        this.BindingData();
    },
    methods: {
        goNext() {
            if (!this.requestReason) {
                Swal.fire({
                    icon: 'warning',
                    title: 'แจ้งเตือน',
                    html: '<label class="fs-5 fw-normal font-family">กรุณาเลือกความประสงค์ขอทำบัตร</label>',
                    confirmButtonText: 'ตกลง',
                });
                return;
            }

            if (!this.pickupLocation) {
                Swal.fire({
                    icon: 'warning',
                    title: 'แจ้งเตือน',
                    html: '<label class="fs-5 fw-normal font-family">กรุณาเลือกสถานที่รับบัตร</label>',
                    confirmButtonText: 'ตกลง',
                });
                return;
            }

            // Ensure the store object exists before assigning properties
            if (!this.$store.state.BuildingAccessCard) {
                this.$store.state.BuildingAccessCard = {};
            }

            this.$store.state.BuildingAccessCard.REQ_TYPE = this.requestReason;
            this.$store.state.BuildingAccessCard.PICKUP_TYPE = this.pickupLocation;

            this.$router.replace('/BACUploadFile');
        },
        BindingData() {

        },
        Authorization() {
            this.Loading = true;

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.Loading = false;

                    this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
                    this.$store.state.AgentCode = response.data.AGENTCODE;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
    },
};

</script>

<style scoped>
/* โทนฟอนต์และกรอบให้เหมือน template ที่ให้มา */
.font-family-bla {
    font-family: "DB Heavent", sans-serif;
}

.card-wrap {
    border: 2px solid #A2B9E2;
    border-radius: 10px;
    background: #fff;
}

/* ให้ตัวอักษรของ input/textarea readonly & disabled เป็นสี #6D8EC9 */
.form-control[readonly],
textarea[readonly],
.form-control:disabled,
textarea:disabled,
.form-control-plaintext {
    color: #6D8EC9 !important;
    /* background-color: var(--bs-body-tertiary) !important; */
    cursor: default;
}

/* ปุ่ม: เต็มความกว้างบนมือถือ และกว้างพอดีบนจอใหญ่ */
.btn-confirm {
    width: 100%;
}

@media (min-width: 768px) {
    .btn-confirm {
        width: 25%;
        min-width: 160px;
        max-width: 320px;
    }
}

/* กรอบแดงไม่มี bg */
.alert-red-border {
    border: 2px solid var(--bs-danger);
    border-radius: 10px;
}

/* ===== Inline label + control ===== */
.inline-field {
    --label-w: 9.5rem;
    /* ปรับความกว้าง label ได้ตามต้องการ */
    display: flex;
    align-items: center;
    gap: .75rem;
}

.inline-label {
    flex: 0 0 var(--label-w);
    max-width: 50%;
    font-weight: 600;
}

.inline-control {
    flex: 1 1 auto;
    min-width: 0;
    /* กัน overflow */
}

/* มือถือ: ซ้อนเป็นแนวตั้งให้ใช้งานง่าย */
@media (max-width: 575.98px) {
    .inline-field {
        flex-direction: column;
        align-items: stretch;
    }

    .inline-label {
        flex: 0 0 auto;
        max-width: 100%;
    }
}
</style>
